import { ActivityData } from "../interfaces/populatedData";

const DELAY_BEOFRE_JOIN_ACTIVITY_BYMODE: {[key in ActivityData['mode']]: number} = {
  "all_leaders": 5000,
  "highlight": 3000,
  "one_group": 5000,
  "one_leader": 5000,
  "pedagogy": 3000
}

export const getDelayBeforeAutoJoinActivity = (mode?: ActivityData['mode']) => {
  const delay = mode ? DELAY_BEOFRE_JOIN_ACTIVITY_BYMODE[mode] : undefined;
  return delay ?? 3000;
};